export type ProgressCallback = (xhr: XMLHttpRequest) => void;
